import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import { login } from "@/api/user";

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("token") || "",
    userInfo: JSON.parse(localStorage.getItem("userInfo")) || null,
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
    },
    SET_USERINFO(state, userInfo) {
      state.userInfo = userInfo;
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    },
    CLEAR_AUTH(state) {
      state.token = "";
      state.userInfo = null;
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
    },
  },
  actions: {
    login({ commit }, userInfo) {
      // 这里应该是API调用，我们模拟一个
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((response) => {
            const { data } = response;
            commit("SET_TOKEN", data);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    logout({ commit }) {
      commit("CLEAR_AUTH");
    },
    // remove token
    resetToken({ commit }) {
      return new Promise((resolve) => {
        commit("SET_TOKEN", "");
        commit("CLEAR_AUTH");
        resolve();
      });
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
    currentUser: (state) => state.userInfo,
  },
});
